
import { defineComponent, useContext } from '@nuxtjs/composition-api'
import { linkDetails } from '~/assets/link'

export default defineComponent({
  props: {
    url: { type: [String, Object], required: false, default: undefined },
    hasIconRight: { type: Boolean, required: false, default: true },
    hasIconExternal: { type: Boolean, required: false, default: false },
  },

  setup(props) {
    const { req } = useContext()
    const currentHost = `//${req?.headers.host || window?.location.host}`
    const { scope } = linkDetails(currentHost, props.url)

    return { scope }
  },
})
